import { usePostHog } from "posthog-js/react";
import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useUser } from "#/contexts/UserContext";
import { useFlashMessages } from "#/pages/Layout";

import { Layout } from "./(components)/Layout";

export default function LoginPage() {
  const { user } = useUser();

  if (user.id) {
    return <Navigate to="/admin/theses" />;
  }
  const location = useLocation();
  const posthog = usePostHog();

  React.useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);

  useFlashMessages();

  return (
    <Layout>
      <div className="relative h-full flex items-center ">
        <div className="flex-col flex gap-y-2 text-muted font-semibold md:text-3xl xl:text-4xl">
          <span>Continue otimizando sua</span>
          <span>rotina com o Recuperar,</span>
          <span className="md:text-2xl xl:text-3xl uppercase tracking-tight text-foreground md:leading-9 xl:leading-10">
            o software dos tributaristas.
          </span>
        </div>
      </div>
    </Layout>
  );
}
